var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessageShieldLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7240_23545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7240_23545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 45,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0127 4H48.0128V48H4.0127V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7240_23545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5088 17.1499H11.4033C7.79627 17.1499 4.87207 20.074 4.87207 23.6812V35.7124C4.87207 39.3195 7.79627 42.2437 11.4033 42.2437H23.7784V47.0562L28.5909 42.2437H34.6065C38.2136 42.2437 41.1378 39.3195 41.1378 35.7124V27.9351",
    fill: "url(#paint0_linear_7240_23545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0205 29.8687C18.0205 28.8245 17.174 27.978 16.1299 27.978C15.0857 27.978 14.2393 28.8245 14.2393 29.8687C14.2393 30.9128 15.0857 31.7593 16.1299 31.7593C17.174 31.7593 18.0205 30.9128 18.0205 29.8687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8955 29.8687C24.8955 28.8245 24.049 27.978 23.0049 27.978C21.9607 27.978 21.1143 28.8245 21.1143 29.8687C21.1143 30.9128 21.9607 31.7593 23.0049 31.7593C24.049 31.7593 24.8955 30.9128 24.8955 29.8687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7637 29.8687C31.7637 28.8245 30.9172 27.978 29.8731 27.978C28.8289 27.978 27.9824 28.8245 27.9824 29.8687C27.9824 30.9128 28.8289 31.7593 29.8731 31.7593C30.9172 31.7593 31.7637 30.9128 31.7637 29.8687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4658 8.00838V15.0776C24.4658 22.2199 29.0877 28.5502 35.8096 30.771C42.5315 28.5502 47.1534 22.2199 47.1534 15.0776V8.00838C43.2153 7.63885 39.3636 6.59961 35.8096 4.94308C32.2556 6.59961 28.4039 7.63885 24.4658 8.00838Z",
    fill: "url(#paint1_linear_7240_23545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6609 14.5596V13.6082C38.6609 12.0317 37.3829 10.7537 35.8066 10.7537C34.2301 10.7537 32.9521 12.0317 32.9521 13.6082V14.5596",
    stroke: "black",
    strokeWidth: 1.71875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7658 19.4595V21.1662H34.8752V19.4595C34.6111 19.2089 34.4455 18.8555 34.4455 18.4627C34.4455 17.7032 35.0611 17.0877 35.8205 17.0877C36.5798 17.0877 37.1955 17.7032 37.1955 18.4627C37.1955 18.8555 37.0299 19.2089 36.7658 19.4595ZM39.6154 14.56H32.0037C31.163 14.56 30.4814 15.2416 30.4814 16.0823V22.1716C30.4814 23.0124 31.163 23.6938 32.0037 23.6938H39.6154C40.4561 23.6938 41.1377 23.0124 41.1377 22.1716V16.0823C41.1377 15.2416 40.4561 14.56 39.6154 14.56Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_23545",
    x1: 23.0049,
    y1: 47.0562,
    x2: 23.0049,
    y2: 17.1499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A189FF",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_23545",
    x1: 35.8096,
    y1: 30.771,
    x2: 35.8096,
    y2: 4.94308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88F754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF496"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7240_23545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.0001,
    height: 44,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageShieldLock);
export default __webpack_public_path__ + "static/media/icon_message_shield_lock.d7e135821f0fff821395222d5c2f3ad3.svg";
export { ForwardRef as ReactComponent };